import { Controller } from "stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const STORAGE_KEY = "manager_tickets_view";

// Remembers the chosen tickets view (list/board) in localStorage. When the page
// is opened without an explicit ?view param (e.g. from the menu), it restores
// the last view the user picked. Toggle links always carry an explicit view
// param, so clicking one never re-triggers the restore (no redirect loop).
export default class extends Controller {
  static values = { current: String, boardUrl: String, listUrl: String };

  connect() {
    const params = new URLSearchParams(window.location.search);
    if (params.has("view")) return;

    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored || stored === this.currentValue) return;

    Turbo.visit(stored === "board" ? this.boardUrlValue : this.listUrlValue, { action: "replace" });
  }

  remember(event) {
    const view = event.currentTarget.dataset.view;
    if (view) localStorage.setItem(STORAGE_KEY, view);
  }
}
